import { useState, useEffect } from "react";

const memoryCache = new Map();

/**
 * Convert storage.googleapis.com URL
 * -> firebasestorage.googleapis.com API URL
 */
export const convertToFirebaseApiUrl = (url) => {
  if (!url) return "";

  const match = url.match(/^https:\/\/storage\.googleapis\.com\/([^/]+)\/(.+)$/);

  if (!match) return url; // already correct format

  const bucket = match[1];
  const path = match[2];

  const encodedPath = encodeURIComponent(path);

  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodedPath}?alt=media`;
}

export function useCachedImageUrl(url) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    if (!url) {
      setSrc("");
      return;
    }

    const convertedUrl = convertToFirebaseApiUrl(url);

    if (memoryCache.has(convertedUrl)) {
      setSrc(memoryCache.get(convertedUrl));
      return;
    }

    memoryCache.set(convertedUrl, convertedUrl);
    setSrc(convertedUrl);

  }, [url]);

  return { src, loading: !src };
}

export default useCachedImageUrl;
